import React from 'react'
import BasicInfo from '../components/registration/BasicInfo'

const Customer = () => {
  return (
    <div>
      <BasicInfo />
    </div>
  )
}

export default Customer